<template>
  <div class="zkml-login" @keyup.enter="login">
    <div class="bg1"></div>
    <div class="login-content">
      <div class="title-view">
        <span class="title">云书·仪表盘运营管理后台</span>
      </div>
      <div class="content">
        <img class="left" src="../assets/images/loginBg2.png" />
        <div class="right">
          <div class="login-text">登录</div>
          <div class="flex-row">
            <el-input
              class="input"
              v-model="form.phone"
              placeholder="手机号"
            ></el-input>
          </div>
          <div class="flex-row">
            <el-input
              class="input"
              v-model="form.msgCode"
              placeholder="请输入验证码"
            ></el-input>
            <el-button
              class="btn"
              type="primary"
              plain
              :disabled="count !== 60"
              @click="sendCode"
            >
              {{
                haveSend
                  ? count !== 60
                    ? `重新发送(${count}s)`
                    : '重新发送'
                  : '获取验证码'
              }}
            </el-button>
          </div>
          <div class="tips-row">
            <el-checkbox class="box" v-model="remeberPhone"> </el-checkbox>
            <span class="grey-text">记住手机号</span>
          </div>

          <div class="login-view">
            <el-button
              class="login-btn"
              :class="{ shadow: isAgree }"
              type="primary"
              round
              :disabled="!isAgree"
              :loading="isLoading"
              @click="login"
              >登录</el-button
            >
          </div>

          <div class="tips-row">
            <el-checkbox class="box" v-model="isAgree"></el-checkbox>
            <span class="grey-text tips">我已阅读并同意</span>
            <span class="xy" @click.stop="setFileShow('server')"
              >《用户协议》</span
            >
            <span class="grey-text tips">和</span>
            <span class="xy" @click.stop="setFileShow('privacy')"
              >《隐私协议》</span
            >
          </div>
        </div>
      </div>
    </div>

    <!--隐私政策-->
    <el-dialog
      :title="fileTitle"
      :visible.sync="tipsVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="800px"
    >
      <iframe
        class="ifr"
        frameborder="0"
        :src="fileUrl"
        :style="{
          height: `${fileHeight}px`,
        }"
      />
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setFileClose">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Config from '@/utils/config';
import Cache from '@/utils/cache';
import { checkPhone } from '@/utils/fnc';

export default {
  data() {
    return {
      form: {
        phone: '',
        msgCode: '',
        requestSource: 'BACKGROUND_MANAGEMENT',
      },
      haveSend: false, // 是否已发送过一次验证码
      remeberPhone: false, // 记住手机号
      isLoading: false,
      isAgree: true, // 阅读并统一
      count: 60,
      dialogTitle: '',
      dialogContent: '',
      timer: null,
      tipsVisible: false,
      fileUrl: '',
      fileHeight: 0,
      fileTitle: '',
    };
  },
  created() {
    this.getCheck();
  },
  methods: {
    /**
     * 是否勾选记住手机号
     */
    getCheck() {
      this.remeberPhone = Cache.get(Config.REMEBER_PHONE) || false;
      if (this.remeberPhone) {
        this.form.phone = Cache.get(Config.LOGINNAME) || '';
      }
    },
    closeDialog() {
      this.dialogTitle = '';
      this.dialogContent = '';
      this.form.msgCode = '';
    },
    setCount() {
      if (this.count > 0) {
        this.count--;
      } else {
        this.timer && clearInterval(this.timer);
        this.count = 60;
      }
      return this.setCount;
    },
    setFileClose() {
      this.fileUrl = '';
      this.fileHeight = 0;
      this.tipsVisible = false;
    },
    setFileShow(type) {
      this.fileHeight = window.innerHeight - 250;
      this.fileUrl =
        type === 'privacy' ? Config.PRIVACY_URL : Config.SERVER_URL;
      this.fileTitle = type === 'privacy' ? '用户隐私政策' : '用户服务协议';
      this.tipsVisible = true;
    },
    /**
     * 发送验证码
     */
    async sendCode() {
      if (!checkPhone(this.form.phone)) {
        this.$message({
          message: '不好意思，请输入正确的手机号哦~',
          type: 'warning',
        });
        return;
      }
      this.haveSend = true;
      this.count--;
      this.timer = setInterval(this.setCount(), 1000);
      const res = await this.$http.post(this.$API.send_code_post, {
        phone: this.form.phone,
      });
      if (res.success) {
        this.$message({
          message: '恭喜你，验证码发送成功哦~',
          type: 'success',
        });
      } else {
        this.$message.error('很遗憾，验证码发送失败，请稍后再试！');
        clearInterval(timer);
        this.count = 60;
      }
    },
    /**
     * 登录
     */
    async login() {
      if (!checkPhone(this.form.phone)) {
        this.$message({
          message: '不好意思，请输入正确的手机号哦~',
          type: 'warning',
        });
        return;
      }
      if (!this.form.msgCode) {
        this.$message({
          message: '不好意思，请输入验证码哦~',
          type: 'warning',
        });
        return;
      }

      Cache.set(Config.REMEBER_PHONE, this.remeberPhone);
      Cache.set(Config.LOGINNAME, this.form.phone);

      this.isLoading = true;
      const res = await this.$http.post(this.$API.login_code_post, this.form);
      this.isLoading = false;
      if (res?.data) {
        const organizationList = res.data.organizationList;
        if (!organizationList.length) {
          // 未加入单位禁止登录
        } else {
          Cache.set(Config.TOKEN, res.data.jwtToken);
          Cache.set(Config.REFRESH_TOKEN, res.data.refreshToken);
          Cache.set(Config.USERINFO, res.data);
          this.$store.dispatch('app/updateUserInfo', res.data);
          if (organizationList.length === 1) {
            this.toMain(organizationList[0], res.data.authId);
          } else {
            this.$router.push({ path: '/organization' });
          }
        }
      }
    },
    async toMain(item, authId) {
      const params = {
        authId,
        organizationId: item.organizationId,
        organizationName: item.organizationName,
        requestSource: 'BACKGROUND_MANAGEMENT',
      };
      this.loading = true;
      this.loadId = item.organizationId;
      const res = await this.$http.post(
        this.$API.set_organization_post,
        params,
      );
      this.loading = false;
      this.loadId = null;
      if (res?.data) {
        this.$store.dispatch('app/updateStaffId', res.data.staffId);
        Cache.set(Config.STAFFID, res.data.staffId);
        Cache.set(Config.CURRENTORGID, item.organizationId);
        this.$router.push({ path: '/dashboardManagement/groupList' });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.zkml-login {
  .bg1 {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('../assets/images/loginBg1.png') center no-repeat;
    background-size: 100% 100%;
  }
  .login-content {
    z-index: 2;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .title-view {
      display: flex;
      justify-content: center;
      align-items: center;
      .title {
        margin-left: 16px;
        font-size: 40px;
        font-weight: bold;
        color: #303133;
        letter-spacing: 4px;
      }
    }
    .content {
      display: flex;
      margin-top: 37px;
      box-shadow: 0px 10px 20px 1px rgba(57, 43, 23, 0.13);
      .left {
        width: 460px;
        height: 500px;
      }
      .right {
        width: 460px;
        height: 500px;
        box-sizing: border-box;
        background-color: #fff;
        padding: 40px;
        .login-text {
          font-size: 30px;
          font-weight: bold;
          color: #303133;
          margin-bottom: 40px;
        }

        .flex-row {
          margin-bottom: 32px;
          display: flex;
          ::v-deep .el-input--mini {
            input {
              height: 50px !important;
              font-size: 16px;
            }
          }
          .btn {
            margin-left: 10px;
            width: 160px;
            height: 50px;
            color: #2f70ff;
            background: rgba(233, 240, 255, 0.39);
            border: 1px solid #c0d4ff;
          }
        }

        .tips-row {
          margin-bottom: 32px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .box {
            margin-right: 5px;
          }
          .grey-text {
            font-size: 14px;
            font-weight: normal;
            color: #606266;
            line-height: 14px;
          }
          .tips {
            color: #909399 !important;
          }
          .xy {
            cursor: pointer;
            font-size: 14px;
            font-weight: normal;
            color: #606266;
            margin-bottom: 2px;
          }
        }

        .login-view {
          margin-bottom: 32px;
          display: flex;
          .login-btn {
            width: 100%;
            height: 50px;
            font-size: 16px;
            font-weight: bold;
            color: #ffffff;
            line-height: 38px;
          }
          .shadow {
            box-shadow: 0px 4px 16px rgba(47, 112, 255, 0.4);
          }
          .is-disabled {
            background-color: #fbf6ed;
            border: 1px solid #fbf6ed;
            font-size: 16px;
            font-weight: bold;
            color: #2f70ff;
          }
        }
      }
    }
  }
}
.ifr {
  width: 100%;
  margin-top: -30px;
  margin-bottom: -20px;
}
</style>
